export default {"src":"/_next/static/media/train_64.c142a4b4.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};